<template>
    <div class="c-programmes-search" :class="[background]">
        <div class="o-container">
            <div class="o-form">
                <div class="o-form__item__container">
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="programmes-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="programmes-search" type="text" :placeholder="t('Mots clés')" v-model="searchInput">
                        <svg class="o-ico -ico-search" role="img">
                            <title>search</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="category">{{ t("Catégories") }}</label>
                        <select @change="changeSelectionCategory()" class="o-select" id="category" v-model="selectedCategory">
                            <option value="">{{ t("Catégories") }}</option>
                            <option v-for="category in categories" :value="category">{{ category }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="champs" v-html="t('Champs d\'intérêt')"></label>
                        <select @change="changeSelectionChamp()" class="o-select" id="champs" v-model="selectedChamp">
                            <option value="" v-html="t('Champs d\'intérêt')"></option>
                            <option v-for="champ in champs" :value="champ">{{ champ }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="programme">{{ t("Programmes") }}</label>
                        <select @change="changeSelectionProgramme()" class="o-select" id="programme" v-model="selectedProgramme">
                            <option value="">{{ t("Programmes") }}</option>
                            <option v-for="programme in programmes" :value="programme">{{ programme }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <!--<div class="o-form__button c-tooltip__wrap">
                        <button class="o-button -button-bg" type="submit">
                            <span class="o-button__icos">
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                            </span>
                            <span class="o-button__text">
                                <span class="o-button__text__elm">
                                    {{ t("Rechercher") }} <span class="sr-only">{{ t("un club selon les critères sélectionnés") }}</span>
                                </span>
                            </span>
                        </button>

                        <div class="c-tooltip">
                            <span class="c-tooltip__text">
                                {{ t("Voir les") }} {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                            </span>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
    </div>

    <div class="c-programmes-search__filters">
        <div class="o-container">
            <div class="c-programmes-search__filters__wrap">
                <div class="c-programmes-search__filters__total">
                    <span>
                        {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                    </span>
                </div>
                <div v-if="tags.length" class="c-programmes-search__filters__actives">
                    <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                        <span>
                            {{ tag.title }}
                        </span>
                        <button @click.prevent="removeTag(tag)" class="c-programmes-search__filters__remove">
                            <span></span>
                            <span></span>
                            <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.title }}</span>
                        </button>
                    </div>
                </div>
                <div v-if="tags.length>0 || searchInput.length>0" class="c-programmes-search__filters__reset">
                    <button @click.prevent="resetSearch()" class="o-button -button-reset">
                        {{ t("Réinitialiser la recherche") }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="o-section__inner" :class="{'-loading': loading}">
        <div class="o-container">
            <div ref="resultsStart" class="c-projects-search__results">
                <template v-for="entry in filteredResultsPaged">
                    <div class="c-search-results__item -show">
                        <div class="c-search-result__header">
                            <span class="c-search-result__title o-title-4">
                                <a :href="entry.url">{{ entry.title }}</a>
                            </span>
                        </div>
                        <div class="c-search-result__desc">
                            <p>
                                {{ entry.description }}
                            </p>
                        </div>
                        <div v-if="entry.categories.length || entry.champs.length || entry.programmes.length" class="c-search-result__tags">
                            <span v-for="category in entry.categories" class="o-tag">
								{{ category.replace(/<[^>]*>?/gm, '') }}
                            </span>
                            <span v-for="champ in entry.champs" class="o-tag">
								{{ champ.replace(/<[^>]*>?/gm, '') }}
                            </span>
                            <span v-for="programme in entry.programmes" class="o-tag">
								{{ programme.replace(/<[^>]*>?/gm, '') }}
                            </span>
                        </div>
                </div>
                </template>
            </div>
            <Pager v-if="totalPages>1" :pagerInfo="{'totalPages': totalPages, 'currentPage': currentPage}" @goToPage="goToPage" />
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import Pager from './Pager.vue';

    export default {
        props: {
            background: {
                type: String,
                default: ''
            }
        },
        components: {
            Pager
        },
        data() {
            return {
                siteId: 1,
                loading: false,
                searchInput: '',
                searchedIds: null,
                selectedCategory: '',
                selectedChamp: '',
                selectedProgramme: '',
                selectedCategories:[],
                selectedChamps:[],
                selectedProgrammes:[],
                categories: [],
                champs: [],
                programmes: [],
                results: [],
                controller: null,
                currentPage: 1,
                languageUrl: '/',
            }
        },
        mounted() {
            let lang = document.documentElement.lang;
            if (lang === 'fr-CA') {
                this.siteId = 1;
            } else {
                this.siteId = 2;
                this.languageUrl = '/en/';
            }

            //load query params
            const currentUrl = new URL(window.location.href);
            const query = currentUrl.search;
            const urlParams = new URLSearchParams(query);
            if (urlParams.has('categories')) {
                this.selectedCategories = urlParams.get('categories').split(',');
            }
            if (urlParams.has('champs')) {
                this.selectedChamps = urlParams.get('champs').split(',');
            }
            if (urlParams.has('programmes')) {
                this.selectedProgrammes = urlParams.get('programmes').split(',');
            }
            if (urlParams.has('s')) {
                this.searchInput = urlParams.get('s');
            }

            this.fetchAttributes();
            if (this.searchInput.length >= 3) this.search();
        },
        computed: {
            filteredResults() {
                let filtered = this.results;

                if (this.searchedIds !== null) {
                    // console.log('searchedIds', this.searchedIds);
                    if (this.searchedIds.length === 0) return [];
                    filtered = filtered.filter(entry => {
                        return this.searchedIds.includes(entry.id);
                    });

                    filtered.sort((a, b) => {
                        return this.searchedIds.indexOf(a.id) - this.searchedIds.indexOf(b.id);
                    });
                }

                if (this.selectedCategories.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedCategories.some(category => entry.categories.includes(category));
                    });
                }

                if (this.selectedChamps.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedChamps.some(champ => entry.champs.includes(champ));
                    });
                }

                if (this.selectedProgrammes.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedProgrammes.some(programme => entry.programmes.includes(programme));
                    });
                }

                return filtered;
            },
            filteredResultsPaged() {
                return this.filteredResults.slice((this.currentPage - 1) * 10, this.currentPage * 10);
            },
            tags() {
                let tags = [];

                this.selectedCategories.forEach(category => tags.push({type: 'category', title: category}));
                this.selectedChamps.forEach(champ => tags.push({type: 'champ', title: champ}));
                this.selectedProgrammes.forEach(programme => tags.push({type: 'programme', title: programme}));
                return tags
            },
            totalPages() {
                let totalPages = 1;

                if (this.filteredResults.length > 10) {
                    totalPages = Math.ceil(this.filteredResults.length / 10);
                }

                return totalPages;
            }
        },
        methods: {
            t(string) {
                return ClubLocalisation[string];
            },
            fetchAttributes() {
                this.loading = true;
                fetch(this.languageUrl + 'api/search/club-index?siteId=' + this.siteId, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.categories !== undefined) this.categories = data.categories;
                    if (data.champs !== undefined) this.champs = data.champs;
                    if (data.programmes !== undefined) this.programmes = data.programmes;
                    if (data.results !== undefined) this.results = data.results;

                    //this.pagerInfo.totalPages = Math.ceil(this.results.length / 10);
                    this.loading = false;
                })
            },
            goToPage(page) {
                this.$refs.resultsStart.scrollIntoView({ behavior: 'smooth' });
                setTimeout(() => {
                    this.currentPage = page;
                }, 100);
            },
            changeSelectionCategory() {
                let current = this.selectedCategory;
                if (current === '') return;
                if (!this.selectedCategories.includes(current)) {
                    this.selectedCategories.push(current);
                }
                this.selectedCategory = '';
                this.refreshUrlQuery();
            },
            changeSelectionChamp() {
                let current = this.selectedChamp;
                if (current === '') return;
                if (!this.selectedChamps.includes(current)) {
                    this.selectedChamps.push(current);
                }
                this.selectedChamp = '';
                this.refreshUrlQuery();
            },
            changeSelectionProgramme() {
                let current = this.selectedProgramme;
                if (current === '') return;
                if (!this.selectedProgrammes.includes(current)) {
                    this.selectedProgrammes.push(current);
                }
                this.selectedChamp = '';
                this.refreshUrlQuery();
            },
            removeTag(tag) {
                if (tag.type === 'category') {
                    this.selectedCategories = this.selectedCategories.filter(category => category !== tag.title);
                } else if (tag.type === 'champ') {
                    this.selectedChamps = this.selectedChamps.filter(champ => champ !== tag.title);
                } else {
                    this.selectedProgrammes = this.selectedProgrammes.filter(programme => programme !== tag.title);
                }
                this.refreshUrlQuery();
            },
            keyupSearch: debounce(function(e) {
                if (this.controller) this.controller.abort();
                if (this.searchInput.length >= 3) {
                    this.search();
                } else {
                    this.searchedIds = null;
                }
            }, 500),
            search() {
                this.loading = true;
                if (this.controller) {
                    this.controller.abort();
                }

                this.controller = new AbortController();

                fetch(this.languageUrl + 'api/search/club?s='+this.searchInput+'&siteId=' + this.siteId, {
                    signal: this.controller.signal,
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error !== undefined) {
                            this.searchedIds = [];
                            this.loading = false;
                            this.currentPage = 1;
                            this.refreshUrlQuery();
                            return;
                        }
                        this.searchedIds = data;
                        this.loading = false;
                        this.currentPage = 1;
                        this.refreshUrlQuery();
                    })
                    .catch(err => {
                        this.searchedIds = null;
                        this.searchInput = '';
                        this.loading = false;
                        this.currentPage = 1;
                        this.refreshUrlQuery();
                    });
            },
            refreshUrlQuery() {
                let query = '';
                if (this.selectedCategories.length > 0) {
                    query += 'categories=' + this.selectedCategories.join(',') + '&';
                }
                if (this.selectedChamps.length > 0) {
                    query += 'champs=' + this.selectedChamps.join(',') + '&';
                }
                if (this.selectedProgrammes.length > 0) {
                    query += 'programmes=' + this.selectedProgrammes.join(',') + '&';
                }
                if (this.searchInput) {
                    query += 's=' + this.searchInput;
                }
                const currentUrl = new URL(window.location.href);
                let pathName = currentUrl.pathname;
                pathName = pathName.replace(/(p\d)/, '');
                let newUrl = currentUrl.origin + pathName + '?' + query;
                if (this.target) {
                    newUrl = this.target + '?' + query;
                    window.location.href = newUrl;
                }
                window.history.pushState({path:newUrl},'',newUrl);
            },
            resetSearch() {
                this.searchInput = '';
                this.searchedIds = null;
                this.selectedCategories = [];
                this.selectedChamps = [];
                this.selectedProgrammes = [];
                this.currentPage = 1;
                this.refreshUrlQuery();
            }
        },
    }
</script>